import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { commonMethods } from 'Utils/commonMethods'
import { USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import { getLocalUserDetails, setLocalWithPayPalData } from 'Utils/LocalStorage_Handler'

function paypal({ setLoading, showError, trackEvent }) {
  const userDetails = getLocalUserDetails()
  const { sentryLog } = commonMethods

  const paypalCreateOrder = async (ele) => {
    const postData = {
      order: {
        userId: userDetails.id,
        billingAddress: 'NA',
        shippingAddress: 'NA',
        states: userDetails.states,
        city: userDetails.city,
        totalQuantity: 1,
        totalAmount: ele.basePrice,
        paymentDate: '2022-12-24T04:51:11.228Z',
        orderDate: '2022-12-24T04:51:11.228Z',
        payOrderId: 'NA',
        subscriptionId: ele.name,
        facilitatorAccessToken: 'NA',
        paymentId: ele.paymentId,
        paymentSource: ele.paymentName,
        paymentStatus: 'Pending',
        orderSatus: 1,
        paymentFrom: 'Web',
        istrialSubscription: ele.subscriptionCode === 'TRS'
      },
      orderDetails: [
        {
          idOrderDetail: 0,
          orderId: 0,
          planId: 'NA',
          serviceName: 'NA',
          subscriptionType: ele.paymentName,
          quantity: 0,
          rate: 0
        }
      ]
    }

    await apiAdapterCoffeeWeb
      .createOrder(postData)
      .then((response) => {
        if (response.data.isSuccess === true) {
          trackEvent(USER_EVENTS.PAYMENT_ORDER_CREATED_PAYPAL)
          InitiatePaypalPayment(ele, response.data.returnLst)
        }
      })
      .catch(() => {
        trackEvent(USER_EVENTS.PAYMENT_CREATION_FAILED_PAYPAL)
        showError({
          title: 'Error !',
          message: `<p>${'An unknown error has been occurred while processing your request.'}</p><p>${'Please try again in sometime.'}</p>`,
          buttonLabel: 'OK'
        })
        sentryLog({ userId: userDetails?.email || userDetails?.phone, screenName: 'Payment PayPal', amount: ele.basePrice, paymentSource: ele.paymentName, subscriptionId: ele.name, errorIn: 'Paypal create order API Failed', description: 'Payment Failed in Paypal' })
      })
  }

  const InitiatePaypalPayment = async (ele, oderData) => {
    setLoading(true)

    const postData = {
      currency_code: 'USD',
      userPhoneNumber: userDetails.phone,
      payPalItems: [
        {
          name: ele.name,
          description: ele.subscriptionSecondName,
          unit_amount: ele.amountInDollars,
          quantity: '1',
          category: ''
        }
      ],
      payer: {
        name: {
          given_name: userDetails.firstName,
          surname: userDetails.lastName
        },
        email_address: userDetails.email,
        address: {
          address_line_1: '',
          address_line_2: '',
          admin_area_2: '',
          admin_area_1: '',
          postal_code: '',
          country_code: ''
        },
        tax_info: {
          tax_id: '',
          tax_id_type: ''
        },
        phone: {
          phone_type: '',
          phone_number: {
            phone_type: '',
            national_number: ''
          }
        }
      }
    }

    try {
      const response = await apiAdapterCoffeeWeb.makePayPalPayment(postData)

      if (response.data.statusCode === 201) {
        setTimeout(() => {
          setLoading(false)
        }, 1000)
        const paypalLink = response.data.returnLst?.links.find((ele) => ele.rel === 'approve')

        window.open(`${paypalLink.href}`, '_parent')

        const paymentDetails = {
          orderId: oderData.orderDetails[0].orderId,
          paymentId: response.data?.returnLst?.id,
          uuid: response.data?.returnLst?.uuid,
          amount: ele.basePrice,
          subName: ele.name,
          paymentSource: ele.paymentName,
          facilitatorAccessToken: response.data?.returnLst?.uuid,
          subscriptionCode: ele.subscriptionCode
        }

        setLocalWithPayPalData(paymentDetails)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      sentryLog({ userId: userDetails?.email || userDetails?.phone, screenName: 'Payment PayPal', amount: ele.basePrice, paymentSource: ele.paymentName, subscriptionId: ele.name, errorIn: 'Paypal MakePayPalPayment Failed', description: 'Payment Failed in Paypal' })
      showError({
        title: 'Error !',
        message: `<p>${'An unknown error has been occurred while processing your request.'}</p><p>${'Please try again in sometime.'}</p>`,
        buttonLabel: 'OK'
      })
    }
  }

  return {
    paypalCreateOrder
  }
}

export default paypal
